import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import classes from "./Layout.module.css";

const Layout = ({ children }) => {
  //判斷path
  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.header}>
          <Header />
        </div>
        <div className={classes.child}>{children}</div>
        <div className={classes.footer}>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Layout;
